// extracted by mini-css-extract-plugin
export default {"root":"VoteStuTable_root__pLy7y","student":"VoteStuTable_student__H0RUt","stuNo":"VoteStuTable_stuNo__c0vmq"};